import Controller from "./class.Controller.js";
import Animations from "./Animations";

/**
 * These are static variables for animation class.
 * Changing these effects animations in all instances of Transporter.
 */

// The delay between messages. Higher means more delay.
var messageDelayModifier = 1;

// The duration of animations. Higher means longer animations.
var durationModifier = 1;

/**
 * The controller class for animations. Controls whether animations
 * are enabled in this instance of Transporter. Might do other stuff
 * in the future.
 */
export default class TransporterAnimations extends Controller {
	constructor() {
		super();
		this.enabled = true;

		for (let key in Animations) {
			this[key] = {
				start: (...args) => {
					const animation = new Animations[key]({
						attributes: {
							animationController: this,
						},
					});
					return animation.start(...args);
				},
			};
		}
	}

	reset() {
		this.enabled = true;
	}

	isEnabled() {
		return this.enabled;
	}

	setEnabled(n) {
		this.enabled = !!n;
	}

	getMessageDelayModifier() {
		return messageDelayModifier;
	}

	setMessageDelayModifier(n) {
		messageDelayModifier = n;
	}

	getDurationModifier() {
		return durationModifier;
	}

	setDurationModifier(n) {
		durationModifier = n;
	}
}
